const KEY_PREFIX = 'paradex';

export const STORAGE_KEY_STARKNET_WALLET_SEED =
  getStorageKey(`starknet-wallet-seed`);

export const STORAGE_KEY_ETHEREUM_WALLET_ADDRESS = getStorageKey(
  `ethereum-wallet-address`,
);

export const getUserPreferencesStorageKey = (userId: string | null) => {
  return getUserStorageKey('user-preferences', userId);
};

export function getUserStorageKey(keyId: string, userId: string | null) {
  const keySuffix = userId ?? 'unauthenticated';
  const fullKey = getStorageKey(`${keyId}-${keySuffix}`);
  return fullKey;
}

function getStorageKey(keyId: string) {
  return `${KEY_PREFIX}-${keyId}`;
}
